module.exports.eighteen = [
  {
    "cities": "Luxembourg",
    "gdp": 9720,
    "automobile_mechanic": 3888,
    "cook": 3971,
    "department_manager": 11196,
    "primary_school_teacher": 9106,
    "sales_assistant": 2884
  },
  {
    "cities": "Montreal",
    "gdp": 3853,
    "automobile_mechanic": 3416,
    "cook": 3201,
    "department_manager": 8996,
    "primary_school_teacher": 3901,
    "sales_assistant": 1915
  },
  {
    "cities": "New York",
    "gdp": 5233,
    "automobile_mechanic": 3761,
    "cook": 5689,
    "department_manager": 9695,
    "primary_school_teacher": 6069,
    "sales_assistant": 3217
  },
  {
    "cities": "Frankfurt",
    "gdp": 3967,
    "automobile_mechanic": 2796,
    "cook": 3577,
    "department_manager": 8665,
    "primary_school_teacher": 5732,
    "sales_assistant": 2449
  },
  {
    "cities": "Zurich",
    "gdp": 6900,
    "automobile_mechanic": 5867,
    "cook": 5655,
    "department_manager": 10669,
    "primary_school_teacher": 8142,
    "sales_assistant": 4503
  },
  {
    "cities": "Chicago",
    "gdp": 5233,
    "automobile_mechanic": 4258,
    "cook": 4077,
    "department_manager": 8487,
    "primary_school_teacher": 5402,
    "sales_assistant": 3235
  },
  {
    "cities": "Geneva",
    "gdp": 6900,
    "automobile_mechanic": 5667,
    "cook": 6064,
    "department_manager": 9952,
    "primary_school_teacher": 8697,
    "sales_assistant": 4657
  },
  {
    "cities": "Los Angeles",
    "gdp": 5233,
    "automobile_mechanic": 3840,
    "cook": 4508,
    "department_manager": 7190,
    "primary_school_teacher": 4562,
    "sales_assistant": 3814
  },
  {
    "cities": "São Paulo",
    "gdp": 743,
    "automobile_mechanic": 950,
    "cook": 1739,
    "department_manager": 5253,
    "primary_school_teacher": 1145,
    "sales_assistant": 774
  },
  {
    "cities": "Milan",
    "gdp": 2874,
    "automobile_mechanic": 2231,
    "cook": 5514,
    "department_manager": 6625,
    "primary_school_teacher": 2556,
    "sales_assistant": 2442
  },
  {
    "cities": "Sydney",
    "gdp": 4781,
    "automobile_mechanic": 3214,
    "cook": 3912,
    "department_manager": 6826,
    "primary_school_teacher": 4629,
    "sales_assistant": 2919
  },
  {
    "cities": "Toronto",
    "gdp": 3853,
    "automobile_mechanic": 3338,
    "cook": 3708,
    "department_manager": 6583,
    "primary_school_teacher": 5132,
    "sales_assistant": 2334
  },
  {
    "cities": "Tel Aviv",
    "gdp": 3476,
    "automobile_mechanic": 2332,
    "cook": 2653,
    "department_manager": 5593,
    "primary_school_teacher": 2583,
    "sales_assistant": 1404
  },
  // {
  //   "cities": "Panama",
  //   "gdp": 1298,
  //   "automobile_mechanic": 758,
  //   "cook": 4875, // strange number!
  //   "department_manager": 1625,
  //   "primary_school_teacher": 921,
  //   "sales_assistant": 758
  // },
  {
    "cities": "Vienna",
    "gdp": 4288,
    "automobile_mechanic": 2979,
    "cook": 3299,
    "department_manager": 6522,
    "primary_school_teacher": 4295,
    "sales_assistant": 2651
  },
  {
    "cities": "Stockholm",
    "gdp": 4551,
    "automobile_mechanic": 3369,
    "cook": 3567,
    "department_manager": 7240,
    "primary_school_teacher": 4182,
    "sales_assistant": 3415
  },
  {
    "cities": "Dublin",
    "gdp": 6567,
    "automobile_mechanic": 2776,
    "cook": 4178,
    "department_manager": 6098,
    "primary_school_teacher": 3912,
    "sales_assistant": 2587
  },
  {
    "cities": "Paris",
    "gdp": 3455,
    "automobile_mechanic": 1958,
    "cook": 3341,
    "department_manager": 5452,
    "primary_school_teacher": 2911,
    "sales_assistant": 2691
  },
  {
    "cities": "Hong Kong",
    "gdp": 4056,
    "automobile_mechanic": 1803,
    "cook": 4966,
    "department_manager": 4754,
    "primary_school_teacher": 2838,
    "sales_assistant": 2143
  },
  {
    "cities": "Brussels",
    "gdp": 3960,
    "automobile_mechanic": 2533,
    "cook": 2972,
    "department_manager": 6018,
    "primary_school_teacher": 3443,
    "sales_assistant": 2829
  },
  {
    "cities": "Istanbul",
    "gdp": 781,
    "automobile_mechanic": 498,
    "cook": 2180,
    "department_manager": 3978,
    "primary_school_teacher": 789,
    "sales_assistant": 532
  },
  {
    "cities": "Copenhagen",
    "gdp": 5113,
    "automobile_mechanic": 4297,
    "cook": 4554,
    "department_manager": 6430,
    "primary_school_teacher": 5152,
    "sales_assistant": 3028
  },
  {
    "cities": "Amsterdam",
    "gdp": 4419,
    "automobile_mechanic": 2980,
    "cook": 2995,
    "department_manager": 5627,
    "primary_school_teacher": 4028,
    "sales_assistant": 2698
  },
  {
    "cities": "Madrid",
    "gdp": 2531,
    "automobile_mechanic": 2577,
    "cook": 3011,
    "department_manager": 4837,
    "primary_school_teacher": 3247,
    "sales_assistant": 2073
  },
  {
    "cities": "Nikosia",
    "gdp": 2347,
    "automobile_mechanic": 1885,
    "cook": 2000,
    "department_manager": 4447,
    "primary_school_teacher": 2145,
    "sales_assistant": 2012
  },
  {
    "cities": "Rio de Janeiro",
    "gdp": 743,
    "automobile_mechanic": 647,
    "cook": 1525,
    "department_manager": 3113,
    "primary_school_teacher": 875,
    "sales_assistant": 583
  },
  {
    "cities": "Kuala Lumpur",
    "gdp": 948,
    "automobile_mechanic": 917,
    "cook": 1508,
    "department_manager": 3003,
    "primary_school_teacher": 912,
    "sales_assistant": 1037
  },
  {
    "cities": "Oslo",
    "gdp": 6808,
    "automobile_mechanic": 3956,
    "cook": 4649,
    "department_manager": 5944,
    "primary_school_teacher": 4918,
    "sales_assistant": 3518
  },
  {
    "cities": "Tokyo",
    "gdp": 3274,
    "automobile_mechanic": 3546,
    "cook": 4045,
    "department_manager": 5413,
    "primary_school_teacher": 4879,
    "sales_assistant": 2998
  },
  {
    "cities": "Bangkok",
    "gdp": 606,
    "automobile_mechanic": 1088,
    "cook": 1357,
    "department_manager": 2865,
    "primary_school_teacher": 788,
    "sales_assistant": 584
  },
  {
    "cities": "Seoul",
    "gdp": 2614,
    "automobile_mechanic": 2080,
    "cook": 2458,
    "department_manager": 3598,
    "primary_school_teacher": 2828,
    "sales_assistant": 1437
  },
  {
    "cities": "Johannesburg",
    "gdp": 531,
    "automobile_mechanic": 867,
    "cook": 1892,
    "department_manager": 2595,
    "primary_school_teacher": 1359,
    "sales_assistant": 668
  },
  {
    "cities": "Lisbon",
    "gdp": 1951,
    "automobile_mechanic": 1231,
    "cook": 2064,
    "department_manager": 2591,
    "primary_school_teacher": 2639,
    "sales_assistant": 953
  },
  {
    "cities": "Jakarta",
    "gdp": 324,
    "automobile_mechanic": 229,
    "cook": 478,
    "department_manager": 1740,
    "primary_school_teacher": 654,
    "sales_assistant": 254
  },
  {
    "cities": "London",
    "gdp": 3579,
    "automobile_mechanic": 3052,
    "cook": 2510,
    "department_manager": 3310,
    "primary_school_teacher": 2896,
    "sales_assistant": 2511
  },
  {
    "cities": "Nairobi",
    "gdp": 143,
    "automobile_mechanic": 423,
    "cook": 908,
    "department_manager": 1711,
    "primary_school_teacher": 438,
    "sales_assistant": 367
  },
  {
    "cities": "Buenos Aires",
    "gdp": 974,
    "automobile_mechanic": 889,
    "cook": 1580,
    "department_manager": 2052,
    "primary_school_teacher": 620,
    "sales_assistant": 1020
  },
  {
    "cities": "Helsinki",
    "gdp": 4179,
    "automobile_mechanic": 3112,
    "cook": 2938,
    "department_manager": 4164,
    "primary_school_teacher": 3714,
    "sales_assistant": 2938
  },
  {
    "cities": "Manila",
    "gdp": 259,
    "automobile_mechanic": 270,
    "cook": 370,
    "department_manager": 1284,
    "primary_school_teacher": 464,
    "sales_assistant": 213
  },
  {
    "cities": "Mumbai",
    "gdp": 167,
    "automobile_mechanic": 270,
    "cook": 635,
    "department_manager": 1314,
    "primary_school_teacher": 395,
    "sales_assistant": 370
  },
  {
    "cities": "Mexico City",
    "gdp": 806,
    "automobile_mechanic": 330,
    "cook": 849,
    "department_manager": 1233,
    "primary_school_teacher": 508,
    "sales_assistant": 326
  },
  {
    "cities": "Bogotá",
    "gdp": 556,
    "automobile_mechanic": 456,
    "cook": 931,
    "department_manager": 1172,
    "primary_school_teacher": 981,
    "sales_assistant": 388
  },
  {
    "cities": "Cairo",
    "gdp": 212,
    "automobile_mechanic": 202,
    "cook": 310,
    "department_manager": 771,
    "primary_school_teacher": 262,
    "sales_assistant": 157
  },
  {
    "cities": "Lagos",
    "gdp": 169,
    "automobile_mechanic": 56,
    "cook": 167,
    "department_manager": 611,
    "primary_school_teacher": 153,
    "sales_assistant": 69
  }
]
